import { A4uProperties as IconComponent } from '@adobe/react-spectrum-workflow/dist/Properties.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Properties(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}